var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-number",class:( _obj = {}, _obj[_vm.size] = _vm.size !== '', _obj )},[_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }